import { isChannelActive } from "./channelActive";

type HasActiveFlag = { active?: boolean; closed?: boolean };

export const filterActiveChannels = <T extends HasActiveFlag>(
    channels: T[]
): T[] => channels.filter((ch) => !ch.closed && isChannelActive(ch));

export const filterInactiveChannels = <T extends HasActiveFlag>(
    channels: T[]
): T[] => channels.filter((ch) => !ch.closed && !isChannelActive(ch));

export const filterClosedChannels = <T extends HasActiveFlag>(
    channels: T[]
): T[] => channels.filter((ch) => ch.closed === true);

export const sortByStatus = <T extends HasActiveFlag>(channels: T[]): T[] => [
    ...filterActiveChannels(channels),
    ...filterInactiveChannels(channels),
    ...filterClosedChannels(channels),
];
